import React from 'react';
import { Sorting, SortingDirection } from '@devexpress/dx-react-grid';
import { HeaderCell } from '../../../DonorMatching/components/DonorMatchingHeader';
import {
    DonorContainer,
    HeaderDonorRow,
    MatchDonorAddress,
    MatchDonorEmail,
    MatchDonorName,
    MatchDonorPhone,
    MatchHeaderLogo,
} from '../../style';

interface MatchDonorHeaderProps {
    sortColumn: string;
    sortDirection: SortingDirection;
    onOrderClick: (sorting: Sorting[]) => void;
    copy: {
        platform: string;
        donorName: string;
        email: string;
        phone: string;
        address: string;
        sort: string;
    };
}

const AutoIntegrationMatchDonorHeader: React.FCC<MatchDonorHeaderProps> = ({
    sortColumn,
    sortDirection,
    onOrderClick,
    copy,
}) => {
    return (
        <HeaderDonorRow>
            <DonorContainer
                container
                alignItems="center"
                className="donorContainer"
            >
                <MatchHeaderLogo item>{copy.platform}</MatchHeaderLogo>
                <MatchDonorName item>
                    <HeaderCell
                        label={copy.donorName}
                        name={'full_name'}
                        onOrderClick={() =>
                            onOrderClick([
                                {
                                    columnName: 'full_name',
                                    direction:
                                        sortDirection === 'asc'
                                            ? 'desc'
                                            : 'asc',
                                },
                            ])
                        }
                        sortColumn={sortColumn}
                        sortDirection={sortDirection}
                        sortLabel={copy.sort}
                    />
                </MatchDonorName>
                <MatchDonorEmail item>{copy.email}</MatchDonorEmail>
                <MatchDonorPhone item>{copy.phone}</MatchDonorPhone>
                <MatchDonorAddress item>{copy.address}</MatchDonorAddress>
            </DonorContainer>
        </HeaderDonorRow>
    );
};

export default AutoIntegrationMatchDonorHeader;
